import {ASSET_GROUP_DEFINITION} from '../../../../../../components/updatejobs/consts';
import {tenantSchedulerBaseRoute} from '../baseRoute';
import {RouteConfig} from '@deviceinsight/ng-ui-scale-lib/api';
import Icon from '../../../../../../assets/icon-updatejobs.svg?react';

export default {
	...tenantSchedulerBaseRoute,
	relativePath: 'workspaceschedule',
	iconSvg: Icon,
	config: {
		onlyWithAssetGroupDefinition: ASSET_GROUP_DEFINITION.WORKSPACE
	}
} satisfies RouteConfig;
